import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { Router } from '@angular/router';

/**
 * 取引先等初期表示画面
 *
 * @export PartnerComponent
 * @class PartnerComponent
 */
@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PartnerComponent implements OnInit {

  /**
   *Creates an instance of PartnerComponent.
   * @param {KYMW00Model} kymw00Model
   * @param {Router} router
   * @memberof PartnerComponent
   */
  constructor(
    public kymw00Model: KYMW00Model,
    private router: Router,
    ) {}

  /**
   * 初期処理
   *
   * @memberof PartnerComponent
   */
  public ngOnInit(): void {
    // ログイン画面起動
    this.loginWindowOpen();
  }

  /**
   * 別ウィンドウPEACE起動
   */
  public eventPeaceOpenHandler(): void {
    // ログイン画面起動
    this.loginWindowOpen();
  }

  /**
   * ログイン画面起動
   */
  private loginWindowOpen(): void {
    var sW = 0;
    sW = window.parent.screen.width;
    var sH = 0;
    sH = window.parent.screen.height;
    var ssW = 0;
    if (sW >= 1920) {
      ssW = 1920;
    } else {
      ssW = sW;
    }

    var ssH = 0;
    var optscb = '';
    if (sH >= 1080) {
      ssH = 1080;
      optscb = ', scrollbars=no';
    } else {
      ssH = sH;
      optscb = ', scrollbars=yes';
    }

    var url = '/login';
    var opt = 'width=' + ssW + ', height=' + ssH + ', menubar=no, toolbar=no, location=no' + optscb;
    window.open(url, null, opt);
    // window.closeするとポップアップブロックが分からないためクローズしない
    // window.close();
  }

}
